import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { GuardRedactionFlagPluginState } from './main.ts';

export const guardRedactionFlagPluginKey: PluginKey<GuardRedactionFlagPluginState> =
	new PluginKey<GuardRedactionFlagPluginState>('guardRedactionFlagPluginKey');
